
let routers = []
const routerContext = require.context('./', true, /index\.js$/)
routerContext.keys().forEach(route => {
  const routerModule = routerContext(route)
  routers = [...routers, ...(routerModule.default || routerModule)]
})
export default [
  {
    path: '/',
    redirect: '/login',
    component: resolve => require(['@/views/index.vue'], resolve),
    children: routers
  }
]
